/*global jQuery, $ */

import Nanobar from 'nanobar';

let refreshResultTimer;
let refreshPrefectureTimer;

let refreshIndicator = new Nanobar({
  classname: 'loading-indicator',
});

function updateLocalityShowButton() {
  let $localities = $('#search-form').find('input[name="locality[]"]:checked');
  let text;

  if ($localities.length === 0) {
    text = '市区町村を選択';
  } else {
    text = $localities.closest('.checkbox')
      .find('.name')
      .map(function () {
        return $(this).text();
      })
      .toArray()
      .join('、');
  }

  $('#locality-dialog-show-button').text(text);
}

function currentUrl() {
  let search = $('#search-form').serialize();
  let url = `${window.location.pathname}?${search}`;

  return url;
}

function requestRefreshResult() {
  if (refreshResultTimer) {
    clearTimeout(refreshResultTimer);
  }

  refreshResultTimer = setTimeout(refreshResult, 250);
}

function refreshResult() {
  refreshIndicator.go(60);

  let url = currentUrl() + ' .main > *';

  $('.main').load(url, function () {
    refreshResultTimer = null;
    refreshIndicator.go(100);
  });

  if ($("#search_modal").css('position') === 'fixed') {
    $("#search_panel_modal").hide();
    $("#search_modal").hide();
  }

  window.history.pushState(null, null, url.split(/ /)[0]);

}

function requestRefreshPrefecture() {
  if (refreshPrefectureTimer) {
    clearTimeout(refreshPrefectureTimer);
  }

  refreshPrefectureTimer = setTimeout(refreshPrefecture, 0);
}

function refreshPrefecture() {
  refreshIndicator.go(60);

  updateLocalityShowButton();

  let url = currentUrl();
  let urlWithContentSelector = url + ' [data-name="address"] > *';

  $('[data-name="address"]').load(urlWithContentSelector, function () {
    refreshPrefectureTimer = null;
    refreshIndicator.go(100);
  });

  window.history.pushState(null, null, url);
}

$(function () {
  $(document)
    .on('change', '#search-form select[name="area_id"]', function () {
      $(this.form).find('select[name="prefecture_id"]').val([]);
      $(this.form).find('input[name="locality_id[]"]').prop('checked', false);
      requestRefreshPrefecture();
    })
    .on('change', '#search-form select[name="prefecture_id"]', function () {
      let $form = $(this);
      let currentArea = $form.find('select[name="area_id"]').val();
      let newArea = this.options[this.selectedIndex].getAttribute('data-area');

      if (currentArea !== newArea) {
        $form.find('select[name="area_id"]').val([]);
      }

      $form.find('input[name="locality[]"]').prop('checked', false);

      requestRefreshPrefecture();
    })
    .on('change', '#search-form :input:not(input[name="locality[]"])', function () {
      requestRefreshResult();
    })
    .on('change', 'input[name="locality[]"]', function () {
      updateLocalityShowButton();
    })
    .on('change', 'select[name="sort"]', function (e) {
      let $sort = $(e.currentTarget);
      $('#search-form input[name="sort"]').val($sort.val());
      requestRefreshResult();
    })
    .on('click', '#search_change, #area_change', function (e) {
      e.preventDefault();

      $("#search_panel_modal").show();
      $("#search_modal").show();
    })
    .on('click', '#search_modal', function (e) {
      if (e.currentTarget !== e.target) {
        return;
      }

      e.preventDefault();

      $("#search_panel_modal").hide();
      $("#search_modal").hide();
    });

  updateLocalityShowButton();
});
